import { API, getRequest } from '@/api/api';
import { generateSearchParams } from '@/utils/generate-search-params';

import type { Quote, QuotesList } from './quote.dto';

/** Same reasoning as the invoice limit: a task's quotes are a handful, not a page. */
const TASK_QUOTES_LIMIT = 50;

/**
 * The quotes raised against one task, and nothing else. Returns the items and writes no
 * store — see `getInvoicesByTask` for why the store method is the wrong thing to call
 * from a card.
 */
export const getQuotesByTask = async (taskId: string): Promise<Quote[]> => {
  const params = generateSearchParams({ limit: TASK_QUOTES_LIMIT, page: 1, task_id: taskId });
  const response = await getRequest<QuotesList>(API.EXPENSES, `/quote?${params}`);
  return response.data.items ?? [];
};
